import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import { Access } from "../Common"
//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            <Access id={`1`}>
              <li>
                <Link to="/dashboard" className=" ">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Dashboards")}</span>
                </Link>
              </li>
            </Access>
            <Access id={`2`}>
              <li>
                <Link to="/laporan_penjualan" className=" ">
                  <i className='bx bx-bar-chart-square'></i>
                  <span>{props.t("Laporan Penjualan")}</span>
                </Link>
              </li>
            </Access>
            <Access id={`5`}>
              <li>
                <Link to="/#" className="has-arrow ">
                  <i className="bx bxs-report"></i>
                  <span>{props.t("Laporan Rekapan")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <Access id={`6`}>
                    <li>
                      <Link to="/laporan_rekapan">{props.t("Laporan Rekapan")}</Link>
                    </li>
                  </Access>
                  <Access id={`8`}>
                    <li>
                      <Link to="/laporan_rekapan_admin">{props.t("Laporan Rekapan Per Admin")}</Link>
                    </li>
                  </Access>
                </ul>
              </li>
            </Access>
            <Access id={`28`}>
              <li>
                <Link to="/laporan_penjualan/tambah" className=" ">
                  <i className='bx bx-cart'></i>
                  <span>{props.t("Input Penjualan")}</span>
                </Link>
              </li>
            </Access>
            <Access id={`11`}>
              <li>
                <Link to="/laporan_laba_rugi" className=" ">
                  <i className="bx bx-file"></i>
                  <span>{props.t("Laporan Laba Rugi")}</span>
                </Link>
              </li>
            </Access>
            <Access id={`12`}>
              <li>
                <Link to="/data_pegawai" className=" ">
                  <i className='bx bx-user-circle'></i>
                  <span>{props.t("Data Pegawai")}</span>
                </Link>
              </li>
            </Access>
            <Access id={`18`}>
              <li>
                <Link to="/laporan_tarik_dana" className=" ">
                  <i className='bx bxs-file'></i>
                  <span>{props.t("Laporan Tarik Dana")}</span>
                </Link>
              </li>
            </Access>
            <Access id={`23`}>
              <li>
                <Link to="/data_toko" className=" ">
                  <i className='bx bx-store' ></i>
                  <span>{props.t("Data Toko")}</span>
                </Link>
              </li>
            </Access>   
            <Access id={`35`}>
              <li>
                <Link to="/panduan_kerja" className=" ">
                  <i className='bx bx-book' ></i>
                  <span>{props.t("Panduan Kerja")}</span>
                </Link>
              </li>
            </Access>   
            <Access id={`40`}>
              <li>
                <Link to="/absensi" className=" ">
                  <i className='bx bx-edit' ></i>
                  <span>{props.t("Laporan Absensi")}</span>
                </Link>
              </li>
            </Access>  
            <Access id={`45`}>
              <li>
                <Link to="/laporan_gaji" className=" ">
                  <i className='bx bx-receipt' ></i>
                  <span>{props.t("Laporan Gaji")}</span>
                </Link>
              </li>
            </Access>
            <Access id={`58`}>
              <li>
                <Link to="/setting_aplikasi" className=" ">
                  <i className='bx bx-cog'></i>
                  <span>{props.t("Setting Aplikasi")}</span>
                </Link>
              </li>
            </Access>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
